{
  "footer-powered-by": "Powered by ",
  "footer-extra": ", a Boise ID company",
  "copyright": "Copyright © {{year}} Salt Technologies LLC."
}
